import { render } from "./ServerList.vue?vue&type=template&id=8197a946&scoped=true"
import script from "./ServerList.vue?vue&type=script&lang=js"
export * from "./ServerList.vue?vue&type=script&lang=js"

import "./ServerList.vue?vue&type=style&index=0&id=8197a946&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8197a946"],['__file',"src/assets/js/pages/Intercom/ServerList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8197a946"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8197a946', __exports__)) {
    api.reload('8197a946', __exports__)
  }
  
  module.hot.accept("./ServerList.vue?vue&type=template&id=8197a946&scoped=true", () => {
    api.rerender('8197a946', render)
  })

}


export default __exports__